<template>
    <div class="main-container">
        <div class="main-container-title-box">
            <div class="main-container-title-box-text">
                <span>
                    Контакты
                </span>
                <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false"
                    color="var(--app-dark-blue-1)">mdi-information</v-icon>
            </div>

        </div>

        <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
            <v-card min-width="300px" min-height="100px">
                <div class="menu-container">
                    <div class="menu-container-title">
                        «Контакты»
                    </div>
                    <div class="menu-container-text">
                        По умолчанию раздел скрыт, показывать когда нужно отобразить контакты совета
                    </div>

                </div>

            </v-card>
        </v-menu>

        <div class="d-flex align-center main-container-info-box" style="margin: 0 24px 40px 24px">
            <v-switch v-model="contacts.isVisible" @change="showInApp" hide-details
                color="var(--app-green-1)"></v-switch>
            <span>Отображать раздел</span>
        </div>

        <div class="main-container-info-box">
            <div class="table-title">
                Контактные данные
            </div>

            <v-form ref="formContacts" class="contacts-form">
                <v-text-field label="Электронная почта" type="text" outlined :rules="emailRules"
                    v-model="contacts.email"></v-text-field>

                <v-text-field label="Номер телефона" type="text" outlined v-mask="'+7 (###) ###-##-##'"
                    :rules="phoneRules" v-model="contacts.phone"></v-text-field>

                <div class="contacts-form-footer">
                    <v-btn @click="saveContacts" style="width: auto !important" class="button-accept">
                        Сохранить
                    </v-btn>
                </div>
            </v-form>
        </div>

    </div>
</template>
<script>

export default {

    data: () => ({
        showInfo: false,
        x: null,
        y: null,
        contacts: {
            email: '',
            phone: '',
            isVisible: false,
        },
        contactsExist: false,
    }),
    computed: {
        emailRules() {
            return [
                v => this.validatorMail(v) || 'Адрес почты введен некорректно',
            ]
        },
        phoneRules() {
            return [
                v => !v || v.length > 16 || 'Номер телефона введен некорректно',
            ]
        },
    },
    methods: {
        openInfo(e) {

            e.preventDefault()

            this.x = e.clientX + 10
            this.y = e.clientY + 10
            this.showInfo = true
        },

        getContacts() {
            this.$axios.get(this.$store.getters.apiAdminPanelV5 + '/ksa-contacts', {
                headers: {
                    authorization: this.$store.getters.adminPanelHeaderAuth,
                    'secret-key': this.$store.state.secretKeyCookie,
                }
            })
                .then(res => {
                    if (!res.data || !Object.keys(res.data).length) return

                    this.contactsExist = true
                    this.contacts.email = res.data.email
                    this.contacts.phone = res.data.phone
                    this.contacts.isVisible = res.data.isVisible
                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },

        updateContacts() {
            const body = {
                email: this.contacts.email,
                phone: this.contacts.phone,
                isVisible: this.contacts.isVisible,
            }
            const method = this.contactsExist ? 'patch' : 'post'
            const url = this.$store.getters.apiAdminPanelV5 + '/ksa-contacts'

            return this.$axios[method](url, body, {
                headers: {
                    authorization: this.$store.getters.adminPanelHeaderAuth,
                    'secret-key': this.$store.state.secretKeyCookie,
                }
            })
                .then(() => {
                    this.contactsExist = true
                    return true
                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                    return false
                })
        },

        showInApp() {
            this.updateContacts()
        },

        saveContacts() {
            if (this.$refs.formContacts.validate()) {
                this.updateContacts().then(ok => {
                    if (ok) {
                        this.$store.commit('errorSet', {
                            key: true,
                            text: 'Данные успешно сохранены',
                            type: 'success'
                        })
                    }
                })
            }
        },

    },
    created() {
        this.getContacts()

    },
}
</script>
<style lang="scss" scoped>
.main-container {

    .main-container-title-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 40px 24px 20px 24px;

        .main-container-title-box-text {
            display: flex;
            align-items: center;

            span {
                font-size: 28px;
                font-weight: 400;
                margin-right: 20px;
            }

        }

    }

    .main-container-info-box {
        .table-title {
            font-size: 24px;
            font-weight: 600;
            margin: 0 24px;
        }

        .contacts-form {
            width: 50%;
            margin: 20px 24px 0 24px;

            .contacts-form-footer {
                margin-top: 40px;
            }
        }

    }
}

.table-title {
    font-size: 24px;
    font-weight: 600;
}
</style>
